const getAlignment = contentfulValue => {
  let flexAlignment;
  let textAlignment;

  switch (contentfulValue) {
    case 'Right':
      textAlignment = 'right';
      flexAlignment = 'flex-end';
      break;
    case 'Center':
      textAlignment = 'center';
      flexAlignment = 'center';
      break;
    default:
      textAlignment = 'left';
      flexAlignment = 'flex-start';
      break;
  }

  return { textAlignment, flexAlignment };
};

export default getAlignment;
